import isEqual from 'lodash/isEqual';
import pickBy from 'lodash/pickBy';

export function areComponentPropsEqual(
  prevProps: Record<string, any>,
  nextProps: Record<string, any>,
): boolean {
  const notFuncDelegator = (value: any) => typeof value !== 'function';

  const prevPropsFiltered = pickBy(prevProps, notFuncDelegator);
  const nextPropsFiltered = pickBy(nextProps, notFuncDelegator);

  return isEqual(prevPropsFiltered, nextPropsFiltered);
}

export function getCookies(): Record<string, string> {
  const cookiesResult: Record<string, string> = {};
  const cookies = document.cookie.split(';');
  if (cookies?.length > 0 && cookies?.[0] !== '') {
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      cookiesResult[key.trim()] = value?.trim() || '';
    }
  }
  return cookiesResult;
}

export function getCookieByName(name: string): string | undefined {
  const cookies = getCookies();
  return cookies?.[name];
}
